export enum IntegrationsTabs {
    Active = 'Active',
    Explore = 'Explore',
}
